import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const PickerAspectGroupContainer = Box.withConfig({
  width: 'full',
  backgroundColor: primitive.$white,
});
